module.exports = "<div class=\"mbgf-col-sm-12 models-box select-box\" data-module=\"models\" data-default-label=\"{{models.defaultlabel}}\" data-msg-required=\"{{models.errorlabel}}\" data-msg-valid=\"{{models.validlabel}}\">\n    <label for=\"models\" id=\"models_label\" runat=\"server\">{{models.label}}</label>\n    [models = {}]\n    <div class=\"message\">\n        <label id=\"txt_models-error\" for=\"txt_models\" style=\"display: inline-block;\"></label>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/models/models.html
// module id = 101
// module chunks = 0 1